import { render, staticRenderFns } from "./PreviousButton.vue?vue&type=template&id=3d0d10f3&"
import script from "./PreviousButton.vue?vue&type=script&lang=js&"
export * from "./PreviousButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d0d10f3')) {
      api.createRecord('3d0d10f3', component.options)
    } else {
      api.reload('3d0d10f3', component.options)
    }
    module.hot.accept("./PreviousButton.vue?vue&type=template&id=3d0d10f3&", function () {
      api.rerender('3d0d10f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/TPEForm/components/PreviousButton/PreviousButton.vue"
export default component.exports